import { Box, Card, Divider, Grid, Stack, Typography } from "@mui/material";
import { blueGrey } from "@mui/material/colors";
import { useEffect, useState } from "react";

const ExecutiveLocationCardV2 = ({
    locations=[]
}) => {

    return ( 
        <Box>
            <Typography variant='h6' gutterBottom>Información por sitios</Typography>
            <Card sx={{p:2, border:`1px solid ${blueGrey[300]}`}}>
                <Stack spacing={0.5}>
                    {locations.map(item => {
                        return(
                            <DataEntry 
                                key={item?.name}
                                text={item?.name}
                                value={item?.count}
                                percentage={parseFloat(item?.percentage).toFixed(2)}
                            />
                        )
                    })}
                </Stack>
                
                
            </Card>
        </Box>
     );
}
 
export default ExecutiveLocationCardV2;

const DataEntry = ({
    text,
    value,
    percentage
}) => {
    return(
        <Box>
            <Grid container spacing={1} alignItems='center'>
                <Grid item xs={12} md={4}>
                    <Box sx={{
                        background: theme => theme.palette.primary.main,
                        color:'white',
                        py:1, px:1,
                        borderRadius:1
                    }}>
                        <Typography >
                            {text}
                        </Typography>
                    </Box>
                </Grid>
                <Grid item xs={12} md={8}>
                    <Stack direction='row' alignItems='flex-end' spacing={1}>
                        <Typography variant="subtitle1">
                            {percentage}%
                        </Typography>
                        <Typography  sx={{
                        }}>
                            ({value} colaboradores)
                        </Typography>
                    </Stack>
                </Grid>
            </Grid>
        </Box>
    )
}